import type { FiltersItemsType, AggregationQueryType } from '../types';

export const transformAggregations: (
  aggregations: AggregationQueryType
) => FiltersItemsType = (aggregations) => {
  const filterItems = {
    careerLevels: aggregations.careerLevels
      ? aggregations.careerLevels.map(
          ({ id, careerLevel: { localizationValue, localizationKey } }) => ({
            id,
            name: localizationValue,
            trackingKey: localizationKey,
          })
        )
      : [],
  };
  return filterItems;
};
